import { CompositeDecorator, ContentBlock, ContentState } from 'draft-js';
import { useState } from 'react';
import { Box, Button, Flex, Text } from 'rebass/styled-components';
import { InputNoForm } from '../../../../components/TextInput';



export const findLinkEntities = (contentBlock: ContentBlock, callback: any, contentState: ContentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, callback);
};

export const Link = (props: any) => {
  const { link, text } = (props.contentState as ContentState).getEntity(props.entityKey).getData()

  return (
    <a style={{ textDecoration: 'underline' }} href={link} target='_blank' >
      {text || props.children}
    </a>
  )
}

export const linkDecorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link,
  },
]);

export const createLinkDecorator = () =>{
  return linkDecorator
}

export const linkDecorators = [
  {
    strategy: findLinkEntities,
    component: Link,
  },
];

export const InsertLinkModalContent = ({ okPressed, onCancel }: { okPressed: (text: string, link: string) => void, onCancel: () => void }) => {
  const [text, setText] = useState<string>('');
  const [link, setLink] = useState<string>('');
  return (
    <Flex flexDirection={'column'}
      padding={4}
      style={{
        background: 'white',
        borderRadius: '20px',
        minWidth: '500px'
      }}>
      <Text mb={3}>Link</Text>
      <Box style={{ width: '100%', height: '1px', backgroundColor: '#d5dce1' }} />

      <Flex mt={3} flexDirection={'column'}>
        <Text>URL</Text>
        <InputNoForm value={link} style={{fontSize:'12px'}} onChange={(e: any) => setLink(e.target.value)} />
        <Text mt={3}>Text</Text>
        <InputNoForm value={text} style={{fontSize:'12px'}} onChange={(e: any) => setText(e.target.value)} />
      </Flex>
      <Flex mt={5} flexDirection='row' alignItems={'center'} justifyContent='center' style={{ width: '100%' }}>
        <Button variant={'primary'} mr={3} style={{ borderRadius: '8px' }} onClick={() => {
          okPressed(text, link)

        }}>Insert</Button>
        <Button variant={'white'} ml={3} onClick={() => onCancel()}>Cancel</Button>
      </Flex>
    </Flex>
  )
}